// eslint-disable-next-line
const style = (theme, scale = 1) => {
  return {
    navLiquidity: {
      padding: 0,
      "& .MuiTabs-indicator": {
        height: "2px",
        background: "var(--tezex-action)",
        borderRadius: "999px",
      },
      justifyContent: "flex-start",

      "&.MuiTabs-root": {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        minHeight: "32px",
      },
      "& .MuiTabs-scroller": {
        display: "flex",
        alignItems: "center",
        minHeight: "32px",
      },
      "& .MuiButtonBase-root": {
        minWidth: 0,
        minHeight: "32px",
        padding: "0 0 7px",
        marginRight: "24px",
        display: "flex",
        alignItems: "center",
        "&.Mui-selected": {
          color: "var(--tezex-text)",
        },
        color: "var(--tezex-text)",
        background: "transparent",
        fontFamily: "Inter",
        fontWeight: 600,
        fontSize: "14px",
        lineHeight: 1.2,
        textTransform: "none",
        transition: "color 160ms ease",
        "&:hover": { color: "var(--tezex-text-secondary)" },
        "&:last-of-type": { marginRight: 0 },
      },
    },
    navApp: {
      "&.MuiTabs-root": {
        display: "flex",
        alignItems: "center",
        height: "55px",
        minHeight: "55px",
        maxHeight: "55px",
        padding: 0,
        border: 0,
        borderRadius: 0,
        background: "transparent",
      },
      "& .MuiTabs-scroller": {
        display: "flex",
        alignItems: "center",
        minHeight: "55px",
      },
      "& .MuiTabs-flexContainer": {
        alignItems: "center",
        gap: "2px",
      },
      "& .MuiButtonBase-root": {
        position: "relative",
        "&.Mui-selected": {
          color: "var(--tezex-text)",
          background: "transparent",
          fontWeight: 700,
        },
        "&::after": {
          content: '""',
          position: "absolute",
          left: "13px",
          right: "13px",
          bottom: "13px",
          height: "2px",
          borderRadius: "2px",
          background: "currentColor",
          transform: "scaleX(0)",
          transformOrigin: "center",
          transition: "transform 220ms cubic-bezier(.3,.8,.3,1)",
        },
        "&.Mui-selected::after": {
          transform: "scaleX(1)",
        },
        fontFamily: "Inter",
        fontStyle: "normal",
        fontWeight: 600,
        lineHeight: 1,
        display: "inline-flex",
        justifyContent: "center",
        textAlign: "center",
        minHeight: "55px",
        minWidth: 0,
        maxWidth: "none",
        padding: "0 13px",
        borderRadius: 0,
        fontSize: "13.5px",
        letterSpacing: "0.02em",
        color: "var(--tezex-text)",
        background: "transparent",
        textTransform: "initial",
        transition: "color 160ms ease",
        "&:hover": { color: "var(--tezex-text)" },
        "&.Mui-disabled": { color: "var(--tezex-faint)" },
        "&.Mui-focusVisible": {
          outline: "2px solid var(--tezex-text-secondary)",
          outlineOffset: "-4px",
          borderRadius: "6px",
        },
        "@media (min-width: 600px) and (max-width: 899px)": {
          padding: "0 10px",
          fontSize: "13px",
          "&::after": { left: "10px", right: "10px" },
        },
        "@media (min-width: 600px) and (max-width: 759px)": {
          padding: "0 8px",
          fontSize: "12.5px",
          "&::after": { left: "8px", right: "8px" },
        },
        "@media (prefers-reduced-motion: reduce)": {
          "&::after": { transition: "none" },
        },
      },
      padding: 0,
      display: "flex",
      justifyContent: "center",
    },
    navHome: {
      root: {
        "&.MuiTabs-root": {
          width: { xs: "260px", sm: "286px" },
          minHeight: "42px",
          padding: "4px",
          border: "1px solid var(--tezex-line)",
          borderRadius: "999px",
          background: "var(--tezex-panel)",
        },
        "& .MuiTabs-scroller": {
          overflow: "hidden !important",
          borderRadius: "999px",
        },
        "& .MuiTabs-flexContainer": {
          minHeight: "32px",
          display: "flex",
          position: "relative",
        },
        "& .MuiTabs-indicator": {
          top: 0,
          bottom: "auto",
          height: "32px",
          zIndex: 1,
          background: "var(--tezex-action)",
          borderRadius: "999px",
          transition:
            "left 240ms cubic-bezier(.22,.8,.24,1), width 240ms cubic-bezier(.22,.8,.24,1)",
          "@media (prefers-reduced-motion: reduce)": { transition: "none" },
        },
      },
      tab: {
        "&.MuiButtonBase-root": {
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "13px",
          fontWeight: 600,
          minHeight: "32px",
          minWidth: 0,
          maxWidth: "none",
          padding: "0 18px",
          zIndex: 2,
          color: "var(--tezex-muted)",
          borderRadius: "999px",
          textTransform: "initial",
          transition: "color 160ms ease",
          "&.Mui-focusVisible": {
            background: "transparent",
            outline: "2px solid var(--tezex-text)",
            outlineOffset: "-4px",
          },
          "&.Mui-selected": {
            color: "var(--tezex-action-text)",
          },
          "&.Mui-disabled": {
            opacity: 1,
            color: "var(--tezex-muted)",
          },
          "&.Mui-selected.Mui-disabled": {
            color: "var(--tezex-action-text)",
          },
          "&.Mui-selected.Mui-focusVisible": {
            outlineColor: "var(--tezex-panel)",
          },
          "&:hover": { color: "var(--tezex-text)" },
          "&.Mui-selected:hover": { color: "var(--tezex-action-text)" },
        },
        wrapper: {
          color: "text.primary",
          textTransform: "initial",
        },
      },
    },
  };
};

export default style;
